var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCanvasWidth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.667,
    height: 15.501,
    viewBox: "0 0 6.667 15.501",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-arrows-alt-v",
    "data-name": "Icon awesome-arrows-alt-v",
    d: "M7.2,11.443H5.8V4.059H7.2a.727.727,0,0,0,.514-1.24L5.105.213a.727.727,0,0,0-1.028,0L1.472,2.818a.727.727,0,0,0,.514,1.24H3.381v7.384H1.986a.727.727,0,0,0-.514,1.24l2.606,2.606a.727.727,0,0,0,1.028,0l2.606-2.606a.727.727,0,0,0-.514-1.24Z",
    transform: "translate(-1.258 0)",
    fill: "#2c2c2c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasWidth);
export default __webpack_public_path__ + "static/media/canvas-width.4a1ac037717b9d155976a39bd19c3eaf.svg";
export { ForwardRef as ReactComponent };